<!-- <avantor-spinner></avantor-spinner> -->
<app-spinner></app-spinner>
<!-- DPIM-6949_changes start -->
<app-avantor-tab-blocker></app-avantor-tab-blocker>
<!-- DPIM-6949_changes end -->
<router-outlet></router-outlet>